import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          if (isLast) {
            return (
              <li key={index} className="flex items-center gap-1">
                <span className="text-foreground-500">{item.label}</span>
              </li>
            );
          }

          return (
            <li key={index} className="flex items-center gap-1">
              {item.path ? (
                <Link
                  to={item.path}
                  className="text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-400">{item.label}</span>
              )}
              <span className="text-foreground-300 mx-1">
                <i className="ri-arrow-right-s-line text-xs"></i>
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}